module.exports = [
  "Prod./ Lager / Gewerbehallen",
  "Ausstellungsfläche (Produktion)",
  "Halle",
  "Industriehalle",
  "Industriehalle mit Freifläche",
  "Lagerfläche",
  "Lager mit Freifläche",
  "Lagerhalle",
  "Hochregallager",
  "Kühlhaus",
  "Kühlregallager",
  "Speditionslager",
  "Werkstatt",
  "Gewerbefläche",
  "Gewerbeeinheit",
  "Gewerbepark",
  "Gewerbezentrum",
  "Spezialobjekt",
  "Werkstatt",
  "Werkstatt (Produktion)",
  "Hallen/Lager/Produktion",
  "Produktions- und Lagerflächen",
];



// WEBPACK FOOTER //
// ./src/data/lager_produktion.js